<template>
  <div>
    <div class="flex items-center justify-center">
      <h3 class="flex items-center justify-center flex-wrap font-bold text-2xl lg:text-3xl">
        {{ header }}
        <span class="flex justify-center items-center">
          <ImgView
            :src="icon"
            class="ml-4 mt-2 min-h-10"
          />
          {{ headerAfterIcon }}
        </span>
      </h3>
    </div>
    <p class="text-EXPONDO-grey-medium mt-2 text-center">
      {{ description }}
    </p>
  </div>
</template>

<script lang="ts">
import ImgView from '~/components/atoms/ImgView/ImgView.vue';

export default defineComponent({
  name: 'CenteredTextIcon',
  components: {
    ImgView,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    header: {
      type: String,
      required: true,
    },
    headerAfterIcon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      required: true,
    },
  },
});
</script>
